export const columns = [
  {
    selector: 'first_name',
    name: 'First Name',
    sortable: true
  },
  {
    selector: 'last_name',
    name: 'Last Name',
    sortable: true
  },
  {
    selector: 'ticket.name',
    name: 'Ticket Type',
    sortable: false
  },
  {
    selector: 'email_address',
    name: 'Email',
    sortable: true
  },
  {
    selector: 'phone_number',
    name: 'Phone',
    sortable: true
  }
];
